'use client'

import { DehydratedState, HydrationBoundary } from '@tanstack/react-query'

import { DiscountProductScreen } from '@/screens/Product'
import { useProduct } from '@/screens/Product/hooks/useProduct'

import { ProductSchemaNode } from '@/shared/lib/seo'

type Props = {
	dehydratedState: DehydratedState
}

const DiscountProductPageContent = () => {
	const { product } = useProduct()

	if (!product) return null

	return (
		<>
			<ProductSchemaNode data={product} categoryName={product.SECTION_NAME || ''} />
			<DiscountProductScreen />
		</>
	)
}

export const DiscountProductClient = ({ dehydratedState }: Props) => (
	<HydrationBoundary state={dehydratedState}>
		<DiscountProductPageContent />
	</HydrationBoundary>
)
